import { Dictionary } from '@hooks/useTranslation'
import { SubscriptionPlan } from '@specs/specs'
import { PaymentsIds } from '@specs/types'

export namespace payments {
    export type IPayment = {
        amount: number
        gold: number
        text: Dictionary
        level: Dictionary
        cdnId: string
    }

    // mapping for stripe test mode
    export const testModePrices: Record<any, IPayment> = {
        price_1MJtteEpu8zjcIHAeHFMic4f: {
            amount: 4.99,
            gold: 25,
            text: 'gold.plans.text_0',
            level: 'gold.plans.level_0',
            cdnId: 'level_0'
        },
        price_1LnhgwEpu8zjcIHAGubNG29n: {
            amount: 14.99,
            gold: 30,
            text: 'gold.plans.text_1',
            level: 'gold.plans.level_1',
            cdnId: 'level_1'
        },
        price_1LnhhwEpu8zjcIHAoUdAjfqd: {
            amount: 39.99,
            gold: 100,
            text: 'gold.plans.text_2',
            level: 'gold.plans.level_2',
            cdnId: 'level_2'
        },
        price_1LnhihEpu8zjcIHAVuCRC1Fw: {
            amount: 99.99,
            gold: 300,
            text: 'gold.plans.text_3',
            level: 'gold.plans.level_3',
            cdnId: 'level_3'
        },
        price_1LnhjNEpu8zjcIHAO8vk7mR3: {
            amount: 299.99,
            gold: 1000,
            text: 'gold.plans.text_4',
            level: 'gold.plans.level_4',
            cdnId: 'level_4'
        }
    } as const

    // mapping for stripe production mode
    export const prices: Record<PaymentsIds, IPayment> = {
        price_1NmvlrEpu8zjcIHAptTGBEJt: {
            amount: 4.99,
            gold: 25,
            text: 'gold.plans.text_0',
            level: 'gold.plans.level_0',
            cdnId: 'level_0'
        },
        price_1MlyBAEpu8zjcIHAO075r4Dk: {
            amount: 14.99,
            gold: 30,
            text: 'gold.plans.text_1',
            level: 'gold.plans.level_1',
            cdnId: 'level_1'
        },
        price_1MlyBBEpu8zjcIHAdgxk2GSt: {
            amount: 39.99,
            gold: 100,
            text: 'gold.plans.text_2',
            level: 'gold.plans.level_2',
            cdnId: 'level_2'
        },
        price_1MlyBCEpu8zjcIHAGu34hXmf: {
            amount: 99.99,
            gold: 300,
            text: 'gold.plans.text_3',
            level: 'gold.plans.level_3',
            cdnId: 'level_3'
        },
        price_1MlyBCEpu8zjcIHAj97AhHuI: {
            amount: 299.99,
            gold: 1000,
            text: 'gold.plans.text_4',
            level: 'gold.plans.level_4',
            cdnId: 'level_4'
        }
    } as const // 3

    export const getPrices = () =>
        Object.keys(process.env.NEXT_PUBLIC_ENV == 'prod' ? prices : testModePrices) as PaymentsIds[] // 4

    export const getPricing = (priceId: keyof typeof prices) =>
        process.env.NEXT_PUBLIC_ENV == 'prod' ? prices[priceId] : testModePrices[priceId] // 4

    // BEGIN Subscriptions
    const isProd = process.env.NEXT_PUBLIC_ENV == 'prod' // 1

    export namespace subscriptions {
        export namespace stripe {
            // actual for 19.10.2023
            export const DEV_stripeSubscriptionsPrices = {
                price_1O2vtyEpu8zjcIHAMx7057Lx: 'year',
                price_1O2vtCEpu8zjcIHAoihq1rx3: 'sixMonths',
                price_1O2vs0Epu8zjcIHAOQ4Ogtiq: 'month'
            } satisfies Record<string, SubscriptionPlan>

            // actual for 19.10.2023
            export const PROD_stripeSubscriptionsPrices = {
                price_1O2wDDEpu8zjcIHAkpIo7tvD: 'year',
                price_1O2wCpEpu8zjcIHACbeyBt2o: 'sixMonths',
                price_1O2w6nEpu8zjcIHAN9Floj6M: 'month'
            } satisfies Record<string, SubscriptionPlan>

            export const getPlan = (
                priceId: keyof typeof PROD_stripeSubscriptionsPrices | keyof typeof DEV_stripeSubscriptionsPrices
            ): SubscriptionPlan | null =>
                isProd
                    ? priceId in PROD_stripeSubscriptionsPrices
                        ? PROD_stripeSubscriptionsPrices[priceId]
                        : null
                    : priceId in DEV_stripeSubscriptionsPrices
                      ? DEV_stripeSubscriptionsPrices[priceId]
                      : null
        } // 4

        export type meta = {
            product: {
                stripe:
                    | keyof typeof stripe.PROD_stripeSubscriptionsPrices
                    | keyof typeof stripe.DEV_stripeSubscriptionsPrices
                robokassa: string
                coinbase: string
            }
            display: {
                price: number
                perWeekPrice: number
                gold: number
                salePercent?: number
            }
        }
    } // 2
    // END Subscriptions
}
